import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    // Filtra os itens com base na condição fornecida
    return items.filter(item => item[filter.key] === filter.value);
  }

}
